let refreshPromise = null;

async function triggerRefresh() {
  if (!refreshPromise) {
    refreshPromise = fetch('https://api.glowytics.com/api/auth/refresh', {
      method: 'POST',
      credentials: 'include'
    }).finally(() => {
      // Prevent stampede: clear promise shortly after resolution
      setTimeout(() => { refreshPromise = null; }, 500);
    });
  }
  return refreshPromise;
}

export async function apiFetch(input, init = {}) {
  const opts = { credentials: 'include', ...init };

  // First attempt
  let res = await fetch(input, opts);
  if (res.status !== 401) return res;

  // On 401, try refresh once
  const rf = await triggerRefresh();
  if (!rf || !rf.ok) return res;

  // Retry original request
  res = await fetch(input, opts);
  return res;
}


